import crypto from "crypto";

const algorithm = "aes-256-cbc";
const password = process.env.HASH_ONE;
const iv =
  (Math.random() + "").substring(2, 10) + (Math.random() + "").substring(2, 10);

export default function encrypt(text) {
  const cipher = crypto.createCipheriv(algorithm, password, iv);
  const encryptedData =
    cipher.update(`${text}`, "utf8", "base64") + cipher.final("base64");
  return {
    content: encryptedData,
    iv: iv,
  };
}

export function encryptInfo(text) {
  const cipher = crypto.createCipheriv(algorithm, password, "5183666c72eec9e4");
  const encryptedData =
    cipher.update(`${text}`, "utf8", "base64") + cipher.final("base64");
  return {
    content: encryptedData,
  };
}
